module.exports = __webpack_public_path__ + "media/src/images/zu_teaching01_page21-8dfa918fff7f2e6bd4e9bc7c55d25299.gif";